import http from './http-common';
import securityService from '../components/security/security.service';

class SetupService {
  getAll(type) {
  let queryParams = new URLSearchParams({CompanyID:securityService.getCompanyIDLoggedInUserId()}).toString();
    console.log('setup service: ', type);
    console.log('queryParams',queryParams)
    return http.get(`/setup/${type}?${queryParams}`);
  }

  getForList(type) {
  let queryParams = new URLSearchParams({CompanyID:securityService.getCompanyIDLoggedInUserId()}).toString();
    console.log('setup service: ', type);
    console.log('queryParams',queryParams)
    return http.get(`/setup/list/${type}?${queryParams}`);
  }

  get(type, id) {
    return http.get(`/setup/${type}/${id}`);
  }

  update(type, data) {
    return http.put(`/setup/${type}/update`, data);
  }

  delete(type, id) {
    return http.delete(`/setup/${type}/${id}`);
  }

  insert(type, value) {
    let queryParams = new URLSearchParams({CompanyID:securityService.getCompanyIDLoggedInUserId()}).toString();
    console.log('setup insert type:', type);
    console.log('setup insert value:', value);
    return http.post(`/setup/${type}/insert?${queryParams}`, value);
  }
}

export default new SetupService();
